function not(boolValue) {
  return !boolValue;
}

export default not;
